import { combineReducers } from "redux";
import { IUser } from "src/redux/state/User";
import { IUtility } from "../state/Utility";
import { AuditReducer, IAuditState } from "./AuditReducer";
import { AuthenticationReducer } from "./AuthenticationReducer";
import { BiddingReducer, IBiddingState } from "./BiddingReducer";
import { BulkOpsReducer, IBulkReduxState } from "./BulkOpsReducer";
import { ContextMenuReducer, IContextMenuState } from "./ContextMenuReducer";
import { CrewScheduleReducer, ICrewSchedule } from "./CrewScheduleReducer";
import { CrewTravelReducer, ICrewTravelState } from "./CrewTravelReducer";
import { CustomPagesReducer, ICustomPagesState } from "./CustomPagesReducer";
import { FlightBuilderReducer, IFlightBuilder } from "./FlightBuilderReducer";
import { FlightPairingStatusReducer, IFlightPairingStatusState } from "./FlightPairingStatusReducer";
import { FlightPairingStatusV2Reducer, IFlightPairingStatusV2State } from "./FlightPairingStatusV2Reducer";
import { FlightScannerReducer, IFlightScannerState } from "./FlightScannerReducer";
import { FlightTimelineReducer, IFlightTimelineState } from "./FlightTimelineReducer";
import { HeartbeatReducer, IHeartbeatState } from "./HeartbeatReducer";
import { LocalizationReducer } from "./LocalizationReducer";
import { IRootModalState, ModalReducer } from "./ModalReducer";
import { IMosaicManager, MosaicManagerReducer } from "./MosaicManagerReducer";
import { IReportingState, ReportingReducer } from "./ReportingReducer";
import { ISnackbarState, SnackbarReducer } from "./SnackbarReducer";
import { IStatus, StatusBarReducer } from "./StatusBarReducer";
import { IStructuresState, StructuresReducer } from "./StructuresReducer";
import { UtilityReducer } from "./UtilityReducer";
import HotelBookings, { IHotelBookingState } from "./HotelPortalReducer";
import Permissions, { IPermissionsState } from "./permissionsReducer";
import flightStatus, { IFlightStatusState } from "./flightStatusReducer";
import UISettings, { IUISettingsState } from "./UISettingsReducer";
import OpsLinkReducer, { IOpsLinkState } from "./OpsLinkReducer";
import PendingReducer, { IPendingState } from "./PendingReducer";

import CreditSettings, { ICreditSettingsState } from "./CreditSettingReducer";
import DispatchDesks, { IDispatchDeskState } from "./DispatchDeskReducer";
import { GendecReducer, IGendecState } from "./GendecReducer";
export interface IRootState {
  utility: IUtility;
  windowManager: IMosaicManager;
  authentication: IUser;
  locales: any;
  timelineFlights: IFlightTimelineState;
  status: IStatus;
  structures: IStructuresState;
  snackbar: ISnackbarState;
  modal: IRootModalState;
  flightBuilderTemplates: IFlightBuilder;
  flightScanner: IFlightScannerState;
  bulkBatch: IBulkReduxState;
  crewSchedule: ICrewSchedule;
  contextMenu: IContextMenuState;
  customPages: ICustomPagesState;
  audit: IAuditState;
  crewTravel: ICrewTravelState;
  reports: IReportingState;
  flightPairingStatus: IFlightPairingStatusState;
  flightPairingStatusV2: IFlightPairingStatusV2State;
  heartbeat: IHeartbeatState;
  bidding: IBiddingState;
  hotelBookings: IHotelBookingState;
  permissions: IPermissionsState;
  flightStatus: IFlightStatusState;
  UISettings: IUISettingsState;
  OpsLinkReducer: IOpsLinkState;
  pending: IPendingState;
  credit: ICreditSettingsState;
  dispatchDesks: IDispatchDeskState;
  gendec: IGendecState;
}

export const reducers = combineReducers<IRootState>({
  utility: UtilityReducer,
  windowManager: MosaicManagerReducer,
  authentication: AuthenticationReducer,
  locales: LocalizationReducer,
  timelineFlights: FlightTimelineReducer,
  status: StatusBarReducer,
  structures: StructuresReducer,
  snackbar: SnackbarReducer,
  modal: ModalReducer,
  flightBuilderTemplates: FlightBuilderReducer,
  flightScanner: FlightScannerReducer,
  bulkBatch: BulkOpsReducer,
  crewSchedule: CrewScheduleReducer,
  contextMenu: ContextMenuReducer,
  customPages: CustomPagesReducer,
  audit: AuditReducer,
  crewTravel: CrewTravelReducer,
  reports: ReportingReducer,
  flightPairingStatus: FlightPairingStatusReducer,
  flightPairingStatusV2: FlightPairingStatusV2Reducer,
  heartbeat: HeartbeatReducer,
  bidding: BiddingReducer,
  hotelBookings: HotelBookings,
  permissions: Permissions,
  flightStatus: flightStatus,
  UISettings: UISettings,
  OpsLinkReducer: OpsLinkReducer,
  pending: PendingReducer,
  credit: CreditSettings,
  dispatchDesks: DispatchDesks,
  gendec: GendecReducer,
});

export type RootState = ReturnType<typeof reducers>;
